module.exports = __webpack_public_path__ + "static/media/client project white.aca8f222.svg";